import {footerStyles, socialIconImageStyles, containerStyles, footerGridStyles, footerTitleStyles, footerDescStyles, footerSectionTitleStyles, footerLinksStyles, footerLinkItemStyles, footerLinkStyles, contactInfoStyles, contactItemStyles, socialMediaStyles, socialLinkStyles, socialIconStyles, socialNameStyles, footerBottomStyles, copyrightStyles} from './styles';

const FooterPage = ({ setCurrentPage }) => {
  const socialLinks = [
    {
      name: "LinkedIn",
      url: "https://www.linkedin.com/groups/10047420/",
      icon: "https://cdn-icons-png.flaticon.com/512/174/174857.png" // LinkedIn icon URL
    },
    {
      name: "Instagram", 
      url: "https://instagram.com/saudibritishnetwork",
      icon: "https://cdn-icons-png.flaticon.com/512/174/174855.png" // Instagram icon URL
    }
  ];

  return (
    <footer style={footerStyles}>
      <div style={containerStyles}>
        <div style={footerGridStyles}>
          <div>
            <h3 style={footerTitleStyles}>Saudi British Network</h3>
            <p style={footerDescStyles}>
              Connecting Saudi Arabia and the United Kingdom through business, culture, and innovation.
            </p>
            <div style={socialMediaStyles}>
              {socialLinks.map((social, index) => (
                <a 
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={socialLinkStyles}
                  title={`Follow us on ${social.name}`}
                >
                  <img 
                    src={social.icon} 
                    alt={`${social.name} icon`}
                    style={socialIconImageStyles}
                  />
                  <span style={socialNameStyles}>{social.name}</span>
                </a>
              ))}
            </div>
          </div>
          <div>
            <h4 style={footerSectionTitleStyles}>Quick Links</h4>
            <ul style={footerLinksStyles}>
              <li style={footerLinkItemStyles}>
                <a 
                  href="#about" 
                  style={footerLinkStyles}
                  onClick={(e) => { e.preventDefault(); setCurrentPage('about'); }}
                >
                  About Us
                </a>
              </li>
              <li style={footerLinkItemStyles}>
                <a 
                  href="#services" 
                  style={footerLinkStyles}
                  onClick={(e) => { e.preventDefault(); setCurrentPage('services'); }}
                >
                  Services
                </a>
              </li>
              <li style={footerLinkItemStyles}>
                <a 
                  href="#membership" 
                  style={footerLinkStyles}
                  onClick={(e) => { e.preventDefault(); setCurrentPage('membership'); }}
                >
                  Membership
                </a>
              </li>
              <li style={footerLinkItemStyles}>
                <a 
                  href="#events" 
                  style={footerLinkStyles}
                  onClick={(e) => { e.preventDefault(); setCurrentPage('events'); }}
                >
                  Events
                </a>
              </li>
              <li style={footerLinkItemStyles}>
                <a 
                  href="#articles" 
                  style={footerLinkStyles}
                  onClick={(e) => { e.preventDefault(); setCurrentPage('articles'); }}
                >
                  Articles
                </a>
              </li>
              <li style={footerLinkItemStyles}>
                <a 
                  href="#contact" 
                  style={footerLinkStyles}
                  onClick={(e) => { e.preventDefault(); setCurrentPage('contact'); }}
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 style={footerSectionTitleStyles}>Contact Info</h4>
            <div style={contactInfoStyles}>
              <p style={contactItemStyles}>Email: info@saudibritishnetwork.com</p>
              {/* <p style={contactItemStyles}>Address: London, United Kingdom</p> */}
            </div>
          </div>
        </div>
        <div style={footerBottomStyles}>
          <p style={copyrightStyles}>&copy; 2025 Saudi British Network. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
export default FooterPage;